"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _forkKnife = _interopRequireDefault(require("cccisd-icons/fork-knife"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fields = exports.fields = ['name', 'question', 'description', 'completeCondition', 'completeAllErrorMessage', 'completeMinErrorMessage', 'minimumNumber', 'afterCompletion', 'shape', 'showItemAs', 'layoutType'];
var initialValues = exports.initialValues = {
  name: 'Menu',
  question: '',
  description: '',
  completeCondition: 'all',
  completeAllErrorMessage: 'You have to complete all menu items before proceeding',
  completeMinErrorMessage: "You have to complete at least :min menu items before proceeding",
  minimumNumber: 1,
  afterCompletion: 'return',
  shape: 'square',
  showItemAs: 'text',
  layoutType: 'grid'
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement(_forkKnife["default"], null);
var validate = exports.validate = function validate(values) {
  var errors = {};
  var completeCondition = values.completeCondition,
    afterCompletion = values.afterCompletion;
  if (completeCondition === 'none' && afterCompletion === 'advance') {
    errors.afterCompletion = 'You cannot auto advance when no menu options are required';
  }
  return errors;
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'me';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  return {};
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  return {};
};